package ca.northroot.app.ui.reports

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import ca.northroot.app.data.*
import ca.northroot.app.ui.components.*
import ca.northroot.app.ui.theme.*
import ca.northroot.app.utils.DateTimeUtils

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun PayReportsScreen(
    db: Db,
    userProfile: UserProfile?,
    companyId: String,
    onBack: () -> Unit
) {
    val isAdmin = userProfile?.role == UserRole.ADMIN || userProfile?.role == UserRole.OWNER
    
    if (!isAdmin) {
        Box(Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
            Text("Access Denied", style = MaterialTheme.typography.headlineMedium, color = Color.Red)
        }
        return
    }

    var jobs by remember { mutableStateOf<List<Job>>(emptyList()) }
    var isLoading by remember { mutableStateOf(false) }

    LaunchedEffect(companyId) {
        isLoading = true
        db.getJobs(companyId, 0).collect { list ->
            jobs = list.filter { it.status == JobStatus.COMPLETED }
            isLoading = false
        }
    }

    Scaffold(
        topBar = {
            TopAppBar(
                title = { 
                    Column {
                        Text("Pay Reports", fontWeight = FontWeight.Black, color = MaterialTheme.colorScheme.primary)
                        Text("EMPLOYEE PERFORMANCE", style = MaterialTheme.typography.labelSmall, color = NorthrootGold)
                    }
                },
                navigationIcon = {
                    IconButton(onClick = onBack) {
                        Icon(Icons.Default.ArrowBack, "Back")
                    }
                }
            )
        },
        containerColor = MaterialTheme.colorScheme.background
    ) { pad ->
        Box(Modifier.padding(pad).fillMaxSize()) {
            if (isLoading) {
                CircularProgressIndicator(modifier = Modifier.align(Alignment.Center))
            } else if (jobs.isEmpty()) {
                Text("No data for reports", modifier = Modifier.align(Alignment.Center), color = Color.Gray)
            } else {
                LazyColumn(
                    modifier = Modifier.fillMaxSize().padding(16.dp),
                    verticalArrangement = Arrangement.spacedBy(16.dp)
                ) {
                    item {
                        NorthrootCard(containerColor = MaterialTheme.colorScheme.primary) {
                            Column(Modifier.padding(24.dp)) {
                                Text("Total Completed Jobs", color = Color.White.copy(alpha = 0.7f), style = MaterialTheme.typography.labelMedium)
                                Text("${jobs.size}", color = Color.White, style = MaterialTheme.typography.headlineMedium, fontWeight = FontWeight.Black)
                            }
                        }
                    }

                    item {
                        Text("Recent Performance", style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.Bold)
                    }

                    items(jobs) { job ->
                        NorthrootCard {
                            Row(Modifier.padding(16.dp), verticalAlignment = Alignment.CenterVertically) {
                                Box(
                                    Modifier.size(40.dp).clip(CircleShape).background(MaterialTheme.colorScheme.primary.copy(alpha = 0.1f)),
                                    contentAlignment = Alignment.Center
                                ) {
                                    Icon(Icons.Default.Check, null, tint = MaterialTheme.colorScheme.primary)
                                }
                                Spacer(Modifier.width(16.dp))
                                Column {
                                    Text(job.customerName, fontWeight = FontWeight.Bold)
                                    Text(job.serviceType, style = MaterialTheme.typography.bodySmall, color = Color.Gray)
                                }
                                Spacer(Modifier.weight(1f))
                                Text(DateTimeUtils.formatDate(job.scheduledDate), fontWeight = FontWeight.Bold)
                            }
                        }
                    }
                }
            }
        }
    }
}
